import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "./MyButton";
import Grid from "@material-ui/core/Grid";
import FileSaver from "file-saver";
import Moment from "react-moment";
import MaxWidthDialog from "./TestDialog";
import SuKienEditdialog from "./SuKienEditDialog";
import SuKienChiTietDialog from "./SuKienChiTietDialog";
import Container from "@material-ui/core/Container";
import Tooltip from "@material-ui/core/Tooltip";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import SuKienTimKiemControl from "./controls/SuKienTimKiemControl";
import ConfirmDialog from "./ConfirmDialog";

const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");

class TestPage extends React.Component {
  columns = [
    { field: "id", headerName: "STT", width: 70 },
    { field: "MaSK", headerName: "Mã số", width: 80 },
    { field: "TenNguonBao", headerName: "Nguồn báo", width: 230 },
    {
      field: "TenSK",
      headerName: "Tên/Quốc tịch",
      width: 230,
      renderCell: (params) => {
        console.log(params);
        return (
          <div style={{ lineHeight: "initial" }}>
            <a
              href="#"
              onClick={() => {
                this.setState({
                  Editting_MaSK: params.getValue("MaSK"),
                  open_edit_sukien: true,
                  showConfirmXoa: false,
                });
              }}
            >
              <div>{params.getValue("TenSK")} </div>{" "}
              <div>{params.getValue("TenQuocGia")}</div>
            </a>
          </div>
        );
      },
    },
    {
      field: "ThoiGian",
      headerName: "Thời gian",
      width: 130,
      renderCell: (params) => (
        <div style={{ lineHeight: "initial" }}>
          <div>
            <Moment format="DD-MM-yyyy HH:mm">
              {params.getValue("ThoiGianBiNan")}
            </Moment>
          </div>
          <div>
            <Moment format="DD-MM-yyyy HH:mm">
              {params.getValue("ThoiGian")}
            </Moment>
          </div>
          <div>
            (
            {myLib.dateDiff(
              params.getValue("ThoiGian"),
              params.getValue("ThoiGianBiNan")
            )}
            )
          </div>
        </div>
      ),
    },
    {
      field: "Lat",
      headerName: "Tọa độ",
      width: 100,
      renderCell: (params) => (
        <div style={{ lineHeight: "initial" }}>
          <div>
            {params.getValue("Lat") !== null
              ? myLib.latToDMS(params.getValue("Lat"))
              : ""}
          </div>
          <div>
            {params.getValue("Lon") !== null
              ? myLib.lonToDMS(params.getValue("Lon"))
              : ""}
          </div>
        </div>
      ),
    },
    {
      field: "ViTri",
      headerName: "Vị trí",
      width: 150,
      renderCell: (params) => (
        <Tooltip arrow title={<p>{params.getValue("ViTri")}</p>}>
          <div style={{ overflow: "ellipsis" }}>{params.getValue("ViTri")}</div>
        </Tooltip>
      ),
    },
    {
      field: "TinhTrang",
      headerName: "Tình trạng/Tóm tắt",
      width: 200,
      renderCell: (params) => (
        <div style={{ lineHeight: "initial" }}>
          <div style={{ color: "red" }}>{params.getValue("TinhTrang")}</div>
          <div>{params.getValue("TomTat")}</div>
        </div>
      ),
    },
    { field: "TenTaiNan", headerName: "Tai nạn", width: 130 },
    {
      field: "DangXL",
      headerName: "Trạng thái",
      width: 130,
      valueGetter: (params) =>
        params.getValue("DangXL") === true ? "Đang xử lý" : "Kết thúc",
    },
    { field: "TenVietTat", headerName: "Đơn vị", width: 200 },
  ];
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi
      open_them_sukien: false, //hien thi form nhap moi su kien
      open_chitiet_sukien: false,
      open_edit_sukien: false, //hien thi form edit su kien
      Editting_MaSK: undefined,
      showConfirmXoa: false,
    };
  }

  popupComp = undefined;

  componentDidMount() {}
  //call khi user thay doi trang
  handlePageChange = (params) => {
    if (this.callbackSearch) {
      this.callbackSearch(params.page);
    }
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
      <div style={{height: this.props.height}}>
        <Box display="flex">
          <div>1111111111</div>
        </Box>

        <Box flexGrow={1}>
          <div
            style={{ backgroundColor: "red", height: `calc(900 - ${220}px)` }}
          >
            222222222232323232
          </div>
        </Box>
        <Box alignSelf="flex-start" display="flex">
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={!global.User.Quyen.R221}
            icon={<AddCircleIcon />}
            text={"Thêm mới"}
            onClick={() => {
              //truy van tu server
              server
                .query("sukien/getdraft")
                .then((response) => {
                  if (response === null) {
                    this.setState({ open_them_sukien: true });
                  } else {
                    this.setState({
                      Editting_MaSK: response.MaSK,
                      open_edit_sukien: true,
                      showConfirmXoa: false,
                    });
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.setState({ open_them_sukien: true });
                });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<EditIcon />}
            text={"Sửa"}
            disabled={
              this.state.Editting_MaSK === undefined || !global.User.Quyen.R221
            }
            onClick={() => {
              this.setState({
                open_edit_sukien: true,
                showConfirmXoa: false,
              });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<DeleteIcon />}
            text={"Xóa"}
            disabled={
              this.state.Editting_MaSK === undefined || !global.User.Quyen.R221
            }
            onClick={() => {
              this.setState({
                open_edit_sukien: true,
                showConfirmXoa: true,
              });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<ImportExportIcon />}
            text={"Xuất Excel"}
            onClick={() => {
              server
                .download("sukien/xuatexcel", this.state.search)
                .then((response) => {})
                .catch((error) => console.log(error));
            }}
          />
        </Box>
        </div>
      </>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  container1: {
    height: "100%",
    backgroundColor: "skyblue",
  },
  gridContainer: {
    height: "600px !important",
  },
});

export default withStyles(styles, { withTheme: true })(TestPage);
